import React, { createRef } from "react";
import { SectionStatusDiv } from "../../../../../../base/basicComponents/status/index";
import ReturnReasonHypelink from "../../../../../../base/basicComponents/returnReasonHypelink";
import { ExpendTextArea } from "../../../../../../base/basicComponents/input";
import styles from "../index.module.scss";
import ApproveClientServerPath from "../approveSeverPath";

const serverPathReturnRef = createRef();
export default class ReadOnlyProcedureProcessClientServerPath extends ApproveClientServerPath {
  render() {
    const { procedureServerPathRef } = this.props;
    const {
      serverPathStatus,
      isServerPathShowEditBtn,
      isServerPathError,
      serverPathReturnReasonInputValue,
    } = this.state.serverPathSectionState;

    return (
      <div className={styles.procedureFileTop}>
        <div
          className={styles.clientServerPath}
          style={{ borderColor: isServerPathError ? "red" : "#b3b3b3" }}
          ref={procedureServerPathRef}
        >
          <div className={styles.approveServerPathTop} data-highlight-id="ClientServerPathType2">
            <div className={styles.procedureServerPathLabel}>Client Server Path:</div>
            <ExpendTextArea
              className={styles.procedureServerPathValue}
              value={this.state.serverPathSectionState.serverPathValue}
              placeholder="Please enter Client Server Path"
              readonly="readonly"
              noMax={true}
              isScrollExpend={true}
              showCount={false}
            />
          </div>
          <div className={styles.serverPathContent} data-highlight-id="ServerPathStatus">
            <div className={styles.statusBlock}>
              <div className={styles.statusLabel}>Status</div>
              <div className={styles.statusContent}>
                <SectionStatusDiv status={serverPathStatus} />
              </div>
            </div>
            <div className={styles.returnReasonBlock}>
              <div className={styles.returnReasonLabel}>Return Reason</div>
              <ReturnReasonHypelink
                inputRef={serverPathReturnRef}
                value={serverPathReturnReasonInputValue}
                isShowEditBtn={isServerPathShowEditBtn}
                isShowReasonLogIcon={this.props.serverPathReturnReasonLog.length > 0}
                reasonLog={this.props.serverPathReturnReasonLog}
              />
            </div>
            <div className={styles.actionBtns}></div>
          </div>
        </div>
      </div>
    );
  }
}
